import { Record } from "../../../fable_modules/fable-library-js.4.24.0/Types.js";
import { Highlighting, Column, Column_$reflection } from "../../../Search.js";
import { class_type, record_type, option_type } from "../../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createObj, equals } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Highlight_matches, Shopfoo_Client_Search_Highlighting__Highlighting_CssClasses_Z779CFBC1 } from "../../../Components/Highlight.js";
import { createElement } from "react";
import React from "react";
import { map, empty, append, singleton, collect, delay, toList } from "../../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { tail, head, isEmpty, ofArray, indexed, singleton as singleton_1 } from "../../../fable_modules/fable-library-js.4.24.0/List.js";
import { FSharpMap__get_Item } from "../../../fable_modules/fable-library-js.4.24.0/Map.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { FiltersModule_apply, Filters, SortDirection, SortDirection__Toggle, Filters__get_BooksTag, Filters__get_BooksAuthorId, Filters__get_BazaarCategory } from "../../../Filters.js";
import { join } from "../../../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { $007CNullOrWhiteSpace$007C_$007C } from "../../../Shopfoo.Common/String.js";
import { Provider } from "../../../Shopfoo.Domain.Types/Catalog.js";
import { React_withKeyAuto_2B31D457 } from "../../../UI.js";
import { TranslationPages_Product__get_Tags, TranslationPages_Product__get_Authors, TranslationPages_Product__get_Category, TranslationPages_Product__get_Description, AppTranslations__get_Product, TranslationPages_Product__get_Name } from "../../../Shopfoo.Shared/Translations.js";
import { Page, Router_navigatePage } from "../../../Routing.js";
import { map as map_1 } from "../../../fable_modules/fable-library-js.4.24.0/Option.js";
import { icon } from "../../../Components/Icon.js";
import sort_down from "@iconify-icons/fa6-solid/sort-down";
import sort_up from "@iconify-icons/fa6-solid/sort-up";
import sort from "@iconify-icons/fa6-solid/sort";

export class ColDef extends Record {
    constructor(Column, SortableBy) {
        super();
        this.Column = Column;
        this.SortableBy = SortableBy;
    }
}

export function ColDef_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Index.ProductsTable.ColDef", [], ColDef, () => [["Column", Column_$reflection()], ["SortableBy", option_type(Column_$reflection())]]);
}

export function Shopfoo_Client_Search_Column__Column_get_NotSortable(col) {
    return new ColDef(col, undefined);
}

export function Shopfoo_Client_Search_Column__Column_SortableBy_312F1088(col, key) {
    return new ColDef(col, key);
}

function $007CColSorted$007C_$007C(colDef, filters) {
    let dir;
    const matchValue = colDef.SortableBy;
    const matchValue_1 = filters.SortBy;
    let matchResult, currentKey_1, dir_1, key_1;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            if ((dir = matchValue_1[1], equals(matchValue, matchValue_1[0]))) {
                matchResult = 0;
                currentKey_1 = matchValue_1[0];
                dir_1 = matchValue_1[1];
                key_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return dir_1;
        default:
            return undefined;
    }
}

export function Shopfoo_Client_Filters_Row__Row_get_Key(row) {
    return `product-${row.Index}`;
}

class Td {
    constructor(filters, row) {
        let matchValue;
        this.filters = filters;
        this.row = row;
        this.bazaarProduct = ((matchValue = this.row.Product.Category, (matchValue.tag === 1) ? undefined : matchValue.fields[0]));
        this.highlightCssClasses = Shopfoo_Client_Search_Highlighting__Highlighting_CssClasses_Z779CFBC1(this.filters.Search.Highlighting, 7);
    }
}

function Td_$reflection() {
    return class_type("Shopfoo.Client.Pages.Product.Index.ProductsTable.Td", undefined, Td);
}

function Td_$ctor_Z47A673E7(filters, row) {
    return new Td(filters, row);
}

function Td__get_num(_) {
    return createElement("td", {
        key: `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-num`,
        children: _.row.Index + 1,
    });
}

function Td__get_sku(_) {
    let elems;
    return createElement("td", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-sku`], (elems = toList(delay(() => collect((matchValue) => singleton(Highlight_matches((children) => createElement("span", createObj(children)), singleton_1(["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-sku-${matchValue[0]}`]), matchValue[1])), indexed(FSharpMap__get_Item(_.row.SearchResult, new Column(1, [])))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function Td__get_bazaarCategory(_) {
    let elems;
    return createElement("td", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-category`], ["className", "w-30"], (elems = toList(delay(() => {
        const matchValue = _.bazaarProduct;
        if (matchValue != null) {
            const bazaarCategory = matchValue.Category;
            return collect((matchValue_1) => singleton(Highlight_matches((children) => createElement("span", createObj(children)), toList(delay(() => append(singleton(["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-category-${matchValue_1[0]}`]), delay(() => (equals(Filters__get_BazaarCategory(_.filters), bazaarCategory) ? singleton(["className", join(" ", _.highlightCssClasses)]) : empty()))))), matchValue_1[1])), indexed(FSharpMap__get_Item(_.row.SearchResult, new Column(4, []))));
        }
        else {
            return singleton(defaultOf());
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function Td__get_bookAuthors(_) {
    let elems_1, elems;
    return createElement("td", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-authors`], (elems_1 = [createElement("div", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-authors-content`], ["className", "w-40 flex-wrap comma-between-children line-clamp-2 group-hover:line-clamp-3"], (elems = toList(delay(() => collect((matchValue) => {
        const result = matchValue[1];
        const i = matchValue[0] | 0;
        const matchValue_1 = result.Target;
        if (matchValue_1.tag === 5) {
            return append((i > 0) ? singleton(", ") : empty(), delay(() => singleton(Highlight_matches((children) => createElement("span", createObj(children)), toList(delay(() => append(singleton(["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-author-${i}`]), delay(() => (equals(Filters__get_BooksAuthorId(_.filters), matchValue_1.fields[0].OLID) ? singleton(["className", join(" ", _.highlightCssClasses)]) : empty()))))), result))));
        }
        else {
            return empty();
        }
    }, indexed(FSharpMap__get_Item(_.row.SearchResult, new Column(6, [])))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Td__get_bookTags(_) {
    let elems_2, elems_1;
    return createElement("td", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-tags`], (elems_2 = [createElement("div", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-tags-content`], ["className", "flex flex-wrap gap-2"], (elems_1 = toList(delay(() => collect((matchValue) => {
        let elems;
        const result = matchValue[1];
        const matchValue_1 = result.Target;
        if (matchValue_1.tag === 6) {
            return singleton(createElement("div", createObj(Helpers_combineClasses("badge", ofArray([["className", "badge-ghost"], ["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-tag-${matchValue[0]}`], ["className", join(" ", toList(delay(() => append(singleton("leading-tight px-1 max-w-[150px] group-hover:max-w-none"), delay(() => ((equals(Filters__get_BooksTag(_.filters), matchValue_1.fields[0]) && equals(_.filters.Search.Highlighting, new Highlighting(0, []))) ? Shopfoo_Client_Search_Highlighting__Highlighting_CssClasses_Z779CFBC1(_.filters.Search.Highlighting, 1 | 4) : empty()))))))], (elems = [Highlight_matches((children) => createElement("span", createObj(children)), ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-tags-text`], ["className", "truncate"]]), result)], ["children", reactApi.Children.toArray(Array.from(elems))])])))));
        }
        else {
            return empty();
        }
    }, indexed(FSharpMap__get_Item(_.row.SearchResult, new Column(7, [])))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function Td__get_description(_) {
    let elems;
    return createElement("td", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-description`], (elems = toList(delay(() => collect((matchValue) => singleton(Highlight_matches((children) => createElement("span", createObj(children)), ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-description-${matchValue[0]}`], ["className", "line-clamp-2 group-hover:line-clamp-3"]]), matchValue[1])), indexed(FSharpMap__get_Item(_.row.SearchResult, new Column(3, [])))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function Td__get_name(_) {
    let elems_1, elems;
    return createElement("td", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-name`], (elems_1 = [createElement("div", createObj(ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-name-content`], ["className", "w-60 line-clamp-2 group-hover:line-clamp-3"], (elems = toList(delay(() => append(collect((matchValue) => singleton(Highlight_matches((children) => createElement("div", createObj(children)), ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-title-${matchValue[0]}`], ["className", "group-hover:inline"]]), matchValue[1])), indexed(FSharpMap__get_Item(_.row.SearchResult, new Column(2, [])))), delay(() => {
        const matchValue_1 = FSharpMap__get_Item(_.row.SearchResult, new Column(5, []));
        let matchResult;
        if (!isEmpty(matchValue_1)) {
            if ($007CNullOrWhiteSpace$007C_$007C(head(matchValue_1).Text) != null) {
                if (isEmpty(tail(matchValue_1))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0: {
                return empty();
            }
            default:
                return append(singleton(createElement("span", {
                    key: `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-sep`,
                    className: "hidden group-hover:inline",
                    children: ":",
                })), delay(() => collect((matchValue_2) => singleton(Highlight_matches((children_1) => createElement("span", createObj(children_1)), ofArray([["key", `${Shopfoo_Client_Filters_Row__Row_get_Key(_.row)}-subtitle-${matchValue_2[0]}`], ["className", "italic ml-1 group-hover:inline"]]), matchValue_2[1])), indexed(matchValue_1))));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ProductsTable(productsTableInputProps) {
    let elems_5, elems_2, children, elems_4;
    const translations = productsTableInputProps.translations;
    const provider = productsTableInputProps.provider;
    const products = productsTableInputProps.products;
    const filters = productsTableInputProps.filters;
    const key = productsTableInputProps.$key;
    const columnDefinitions = toList(delay(() => append(singleton(Shopfoo_Client_Search_Column__Column_SortableBy_312F1088(new Column(0, []), new Column(0, []))), delay(() => append(singleton(Shopfoo_Client_Search_Column__Column_SortableBy_312F1088(new Column(1, []), new Column(1, []))), delay(() => append(equals(provider, new Provider(0, [])) ? singleton(Shopfoo_Client_Search_Column__Column_SortableBy_312F1088(new Column(4, []), new Column(4, []))) : empty(), delay(() => append(singleton(Shopfoo_Client_Search_Column__Column_SortableBy_312F1088(new Column(2, []), new Column(2, []))), delay(() => append(equals(provider, new Provider(1, [])) ? append(singleton(Shopfoo_Client_Search_Column__Column_SortableBy_312F1088(new Column(6, []), new Column(6, []))), delay(() => singleton(Shopfoo_Client_Search_Column__Column_SortableBy_312F1088(new Column(7, []), new Column(7, []))))) : empty(), delay(() => singleton(Shopfoo_Client_Search_Column__Column_get_NotSortable(new Column(3, [])))))))))))))));
    return createElement("table", createObj(Helpers_combineClasses("table", ofArray([["key", `${key}-content`], ["className", "table-pin-rows w-full border-collapse"], (elems_5 = [createElement("thead", createObj(ofArray([["key", "product-thead"], (elems_2 = [React_withKeyAuto_2B31D457((children = toList(delay(() => map((colDef_3) => {
        const colDef = colDef_3;
        let patternInput;
        const matchValue = colDef.Column;
        patternInput = ((matchValue.tag === 1) ? ["sku", "SKU"] : ((matchValue.tag === 2) ? ["name", TranslationPages_Product__get_Name(AppTranslations__get_Product(translations))] : ((matchValue.tag === 3) ? ["description", TranslationPages_Product__get_Description(AppTranslations__get_Product(translations))] : ((matchValue.tag === 4) ? ["category", TranslationPages_Product__get_Category(AppTranslations__get_Product(translations))] : ((matchValue.tag === 5) ? ["name", TranslationPages_Product__get_Name(AppTranslations__get_Product(translations))] : ((matchValue.tag === 6) ? ["authors", TranslationPages_Product__get_Authors(AppTranslations__get_Product(translations))] : ((matchValue.tag === 7) ? ["tags", TranslationPages_Product__get_Tags(AppTranslations__get_Product(translations))] : ["num", "#"])))))));
        const text = patternInput[1];
        const key_1 = patternInput[0];
        return createElement("th", createObj(toList(delay(() => append(singleton(["key", `product-th-${key_1}`]), delay(() => append(singleton(["scope", "col"]), delay(() => append((colDef.SortableBy != null) ? append(singleton(["className", "cursor-pointer hover:bg-base-200 transition-colors select-none"]), delay(() => singleton(["onClick", (_arg) => {
            let activePatternResult, dir;
            const nextDir = (activePatternResult = $007CColSorted$007C_$007C(colDef, filters), (activePatternResult != null) ? ((dir = activePatternResult, SortDirection__Toggle(dir))) : (new SortDirection(0, [])));
            Router_navigatePage(new Page(5, [new Filters(filters.CategoryFilters, filters.Search, map_1((key_5) => [key_5, nextDir], colDef.SortableBy))]));
        }]))) : empty(), delay(() => {
            let elems_1;
            return singleton((elems_1 = [createElement("div", createObj(toList(delay(() => append(singleton(["key", `product-th-${key_1}-content`]), delay(() => {
                let activePatternResult_1, dir_1;
                if (colDef.SortableBy == null) {
                    return singleton(["children", `${text}`]);
                }
                else {
                    const patternInput_1 = (activePatternResult_1 = $007CColSorted$007C_$007C(colDef, filters), (activePatternResult_1 != null) ? ((dir_1 = activePatternResult_1, ["text-accent", icon((dir_1.tag === 1) ? sort_down : sort_up)])) : ["text-base-content/30", icon(sort)]);
                    return append(singleton(["className", "flex items-center gap-2"]), delay(() => {
                        let elems;
                        return singleton((elems = [`${text}`, createElement("span", {
                            key: `product-th-${key_1}-sort-icon`,
                            className: patternInput_1[0],
                            children: patternInput_1[1],
                        })], ["children", reactApi.Children.toArray(Array.from(elems))]));
                    }));
                }
            }))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
        }))))))))));
    }, columnDefinitions))), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    })))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("tbody", createObj(ofArray([["key", "product-tbody"], (elems_4 = toList(delay(() => map((row) => {
        let elems_3;
        return createElement("tr", createObj(ofArray([["key", Shopfoo_Client_Filters_Row__Row_get_Key(row)], ["className", "group hover:bg-accent hover:fg-accent hover:cursor-pointer"], ["onClick", (_arg_2) => {
            Router_navigatePage(new Page(6, [row.Product.SKU]));
        }], (elems_3 = toList(delay(() => {
            const td = Td_$ctor_Z47A673E7(filters, row);
            return collect((colDef_4) => {
                const matchValue_3 = colDef_4.Column;
                return (matchValue_3.tag === 2) ? singleton(Td__get_name(td)) : ((matchValue_3.tag === 3) ? singleton(Td__get_description(td)) : ((matchValue_3.tag === 4) ? singleton(Td__get_bazaarCategory(td)) : ((matchValue_3.tag === 5) ? singleton(Td__get_name(td)) : ((matchValue_3.tag === 6) ? singleton(Td__get_bookAuthors(td)) : ((matchValue_3.tag === 7) ? singleton(Td__get_bookTags(td)) : ((matchValue_3.tag === 1) ? singleton(Td__get_sku(td)) : singleton(Td__get_num(td))))))));
            }, columnDefinitions);
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }, FiltersModule_apply(products, translations, filters)))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
}

